// FT-082: sync the bookings filter state with the URL query so a filtered view is
// shareable/bookmarkable and survives refresh/back. The component owns `filters`;
// this mixin only reads it into / writes it out of `this.$route.query`.

// Booking states are stored in Cyrillic; keep the URL readable by mapping them to
// Latin slugs (same keys as i18n bookings_states) on the way out and back.
const STATE_TO_SLUG = {
  "Новая": "new",
  "Подтверждена": "accepted",
  "Не подтверждена": "not_accepted",
  "В обработке": "in_work",
  "Недозвон": "abandoned",
  "Отказ клиента": "decline",
  "Нет машин": "no_cars",
  "Ожидает ответа клиента": "wait_answer",
  "Ожидает оплаты": "wait_pay",
  "Активная": "active",
  "Отмена": "cancel",
  "Отъездила": "rided",
  "Вернуть залог": "return_deposit",
  "Другое": "other",
};
const SLUG_TO_STATE = Object.fromEntries(
  Object.entries(STATE_TO_SLUG).map(([state, slug]) => [slug, state])
);

export default {
  methods: {
    // Read filter fields from the URL into this.filters. Call in created() so the
    // initial load and the command bar pick up the URL state.
    readFiltersFromQuery() {
      const q = this.$route.query || {};
      const next = { ...this.filters };
      next.search = q.search || null;
      next.state = q.state ? [].concat(q.state).map((s) => SLUG_TO_STATE[s] || s) : [];
      next.car_id = q.car_id ? Number(q.car_id) : null;
      next.responsible = q.responsible || null;
      next.date_from = q.date_from || null;
      next.date_to = q.date_to || null;
      next.payment_status = q.payment_status || null;
      next.overdue = q.overdue === "1" || q.overdue === "true";
      next.deposit_return = q.deposit_return === "1" || q.deposit_return === "true";
      // board-only sort keys (present in this.filters on the board)
      if ("sort_by" in this.filters && q.sort_by) next.sort_by = q.sort_by;
      if ("sort_dir" in this.filters && q.sort_dir) next.sort_dir = q.sort_dir;
      this.filters = next;
    },
    filtersToQuery(extra) {
      const f = this.filters || {};
      const q = {};
      if (f.search) q.search = f.search;
      if (f.state && f.state.length) q.state = f.state.map((s) => STATE_TO_SLUG[s] || s);
      if (f.car_id) q.car_id = String(f.car_id);
      if (f.responsible) q.responsible = f.responsible;
      if (f.date_from) q.date_from = f.date_from;
      if (f.date_to) q.date_to = f.date_to;
      if (f.payment_status) q.payment_status = f.payment_status;
      if (f.overdue) q.overdue = "1";
      if (f.deposit_return) q.deposit_return = "1";
      if (f.sort_by && f.sort_by !== "created_at") q.sort_by = f.sort_by;
      if (f.sort_dir && f.sort_dir !== "desc") q.sort_dir = f.sort_dir;
      return { ...q, ...(extra || {}) };
    },
    // replace (not push) so filtering doesn't spam browser history; catch the
    // NavigationDuplicated rejection when the query is unchanged.
    writeFiltersToQuery(extra) {
      this.$router.replace({ query: this.filtersToQuery(extra) }).catch(() => {});
    },
  },
};
